const Condition = require('./Condition');

const InspiredCondition = function(instigator, owner, battleState, potency, charges) {
  const condition = new Condition(instigator, owner, battleState, potency, charges);
  condition.handle = 'inspired';
  return condition;
};
module.exports = InspiredCondition;
